<template>
  <div class="row">
    <div class="col-12 col-sm-6">
      <WCLabel id="select_amount">
        {{ $t('selectAnAmount') }}<span class="text-danger pl-1">*</span>
      </WCLabel>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <WCSelectBoxGroup
            v-model="selected"
            class="flex-wrap align-item-center"
            role="radiogroup"
            aria-labelledby="select_amount"
          >
            <WCSelectBox
              v-for="(amount, i) in sortedGiftCardAmount"
              :key="i"
              class="wc-select-box flex-grow-1"
              :model="custom ? false : value"
              :id="amount"
              @change="change($event, amount, false)"
              ><span class="text-center font-size-base">{{ amount | currency }}</span></WCSelectBox
            >
            <WCSelectBox
              class="flex-grow-1"
              :model="custom ? 'custom' : false"
              id="custom"
              @change="change($event, amount, true)"
              ><span class="text-center font-size-base">{{ $t('custom') }}</span></WCSelectBox
            >
          </WCSelectBoxGroup>
        </div>
        <div class="col-12">
          <WCInputGroup v-if="custom">
            <template v-slot:left>
              <span class="input-group-text border-dark">{{ $t('dollarSign') }}</span>
            </template>
            <input
              name="amount"
              id="gift-card-custom-amount__input"
              autocomplete="transaction-amount"
              class="form-control border-dark"
              type="number"
              v-model.number="amount"
              @input="change(null, $event.target.value, true)"
              :aria-label="$t('customPrice')"
            />
          </WCInputGroup>
        </div>
      </div>
    </div>
    <div class="col-12 pt-1">
      <span
        class="text-danger"
        id="gift-card-low-amount__message"
        v-if="amount < giftCard.minCardValue"
      >
        {{ $t('amountMustBeAtLeast') }} {{ giftCard.minCardValue }}.
      </span>
      <span
        class="text-danger"
        id="gift-card-high-amount__message"
        v-if="amount > giftCard.maxCardValue"
      >
        {{ $t('amountMustBeLessOrEqual') }} {{ giftCard.maxCardValue }}.
      </span>
    </div>
  </div>
</template>
<script>
import WCSelectBoxGroup from '@/modules/forms/components/WCSelectBoxGroup/WCSelectBoxGroup.vue';
import WCSelectBox from '@/modules/forms/components/WCSelectBox/WCSelectBox.vue';
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';
import WCInputGroup from '@/modules/forms/components/WCInputGroup/WCInputGroup.vue';

export default {
  name: 'WCGiftCardAmountSelector',
  components: {
    WCSelectBox,
    WCSelectBoxGroup,
    WCInputGroup,
    WCLabel,
  },
  data() {
    return {
      amount: {},
      selected: null,
      custom: false,
    };
  },
  props: {
    giftCard: {
      Type: Object,
    },
    value: {},
  },

  methods: {
    change(selected, amount, custom) {
      this.selected = selected;
      this.amount = parseFloat(amount);
      this.custom = custom;

      this.$emit('input', parseFloat(amount));
    },
  },

  computed: {
    /**
     * Sort gift card amounts in ascending order
     */
    sortedGiftCardAmount() {
      return this.giftCard?.egiftCardAmounts?.slice(0).sort((a, b) => a - b);
    },
  },
};
</script>
